import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Card,
  Form,
  ModalFooter,
  FormGroup,
  Input,
  FormText
} from "reactstrap";
import { connect } from "react-redux";

import TextInput from "../TextInput";

import PropTypes from "prop-types";

const UploadModal = ({ open, onClose, hubData, isEdit }) => {
  const [documentName, setDocumentName] = useState("");
  // const [error, setError] = useState('');

  useEffect(() => {
    if (hubData) {
      // @TODO: review this code
      setDocumentName("sdfsdf");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Modal zIndex={2000} centered isOpen={open} toggle={onClose}>
      <div>
        <Card className="bg-secondary shadow-none border-0">
          <div className="card-body px-lg-5 py-lg-5">
            <div className="text-center text-black-50 mb-4">
              <h3>Upload Document</h3>
              {/* {error && (
                <p className="text-center" style={{ color: '#f24822' }}>
                  Something went wrong.
                </p>
              )} */}
            </div>
            <Form onSubmit={handleSubmit}>
              <TextInput
                type="text"
                value={documentName}
                placeholder="Document Name"
                onChange={(e) => setDocumentName(e.target.value)}
                required
              />

              <FormGroup>
                <Input type="file" name="file" />
                <FormText color="muted">
                  This is some placeholder block-level help text for the above
                  input. It's a bit lighter and easily wraps to a new line.
                </FormText>
              </FormGroup>

              <ModalFooter className="d-flex justify-content-between">
                <Button
                  color="link"
                  className="btn-link-dark"
                  onClick={onClose}>
                  Close
                </Button>{" "}
                <Button
                  onClick={handleSubmit}
                  color="second"
                  style={{ color: "#fff200" }}>
                  {isEdit ? "Save Changes" : "Upload"}
                </Button>
              </ModalFooter>
            </Form>
          </div>
        </Card>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({ AuthUser }) => ({
  isLoggedIn: AuthUser.isLoggedIn
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal);

UploadModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  hubData: PropTypes.object,
  isEdit: PropTypes.bool
};
